import { render, staticRenderFns } from "./real-time.vue?vue&type=template&id=17b7e3fb&scoped=true"
import script from "./real-time.vue?vue&type=script&lang=js"
export * from "./real-time.vue?vue&type=script&lang=js"
import style0 from "./real-time.vue?vue&type=style&index=0&id=17b7e3fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b7e3fb",
  null
  
)

export default component.exports